<script>
  import options from './EditFrivilligProfile.options'
  export default options
</script>

<template>
  <article class="kb-stafet-donation-flow kb-edit-frivillig-profile">
    <section class="kb-stafet-step kb-optimizely-forms kb-stafet-donation-flow__step">
    
      <div class="kb-stafet-step__divider kb-stafet-step__divider--smaller"></div>
      <ProfilePicture :content="activeProfilePicture" :userId="userData.id" :hasProfileImage="hasProfileImage" type="frivillig"></ProfilePicture>
      <div class="kb-stafet-step__divider kb-stafet-step__divider--smaller"></div>

      <div class="kb-stafet-step__input-wrapper">
        <h2 class="kb-stafet-step__step-section-title">{{ getLabel("userSettingsTitle") }}</h2>

        <div class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half">
          <FormInputNameField
            isRequired
            :readOnly="true"
            v-model="userData.firstName"
            :modelValue="userData.firstName"
            fieldName="firstName"
            :label="getLabel('firstNameLabel')"
          />

          <FormInputNameField
            isRequired
            :readOnly="true"
            v-model="userData.lastName"
            :modelValue="userData.lastName"
            fieldName="lastName"
            :label="getLabel('lastNameLabel')"
          />

        </div>

          <FormAddressField
            :disabled="true"
            v-model:address-line-value="userData.address"
            v-model:zip-code-value="userData.postalCode"
            v-model:city-value="userData.city"
            :addressLabel="getLabel('addressLineLabel')"
            :zipCodeLabel="getLabel('postalCodeLabel')"
            :cityLabel="getLabel('cityLabel')"
            :isValidationError="false"
            errorMessageLabel=""
          />

          <div class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half">
            <FormInputTextField
              isRequired
              :readOnly="true"
              v-model="userData.phoneNumber"
              :modelValue="userData.phoneNumber"
              fieldName="phoneNumber"
              :label="getLabel('phoneNumberLabel')"
            />


            <FormInputTextField
              isRequired
              :readOnly="true"
              type="email"
              v-model="userData.email"
              :modelValue="userData.email"
              fieldName="email"
              :label="getLabel('emailLabel')"
            />
          </div>


          <div class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half">
            <FormInputTextField
              isRequired
              :readOnly="true"
              type="password"
              v-model="password"
              :modelValue="password"
              fieldName="password"
              :label="getLabel('passwordLabel')"
            />
          </div>

           <a class="kb-link" :href="getLabel('editUserInformationLinkHref')">
            {{ getLabel('editUserInformation') }} 
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 24"><path fill="#fff" fill-rule="evenodd" d="m20.214 3.835-6.055-.3-.05-.999 6.555.325c.275.013.51.248.524.524l.324 6.554-.998-.05-.3-6.054ZM6.758 16.583l10.1-10.1.707.707-10.1 10.1-.707-.707ZM2.75 4.75h-.5v17.5h17.5v-9.781h-1v8.781H3.25V5.75h8.781v-1H2.75Z" clip-rule="evenodd"/></svg>
           </span>
          </a>

      </div>

      <div class="kb-stafet-step__input-wrapper">
        <div class="kb-stafet-step__divider kb-stafet-step__divider--smaller"></div>
        <h2 class="kb-stafet-step__step-section-title">{{ getLabel("visibleToOthersTitle") }}</h2>

        <FormInputTextarea 
          v-model="description"
          fieldName="description"
          :modelValue="description"
          :placeholder="getLabel('descriptionPlaceholder')"
          :label="getLabel('descriptionLabel')"
          :maxlength="300"
        />

        <FormCheckbox 
          fieldName="addressVisible"
          :modelValue="addressVisible.toString()"
          v-model="addressVisible"
          :label="getLabel('addressVisibleLabel')"
          :onChangeCallback="(e) => addressVisible = e.target.checked"
        />

        <FormCheckbox 
          fieldName="phoneNumberVisible"
          :modelValue="phoneNumberVisible.toString()"
          v-model="phoneNumberVisible"
          :label="getLabel('phoneNumberVisibleLabel')"
          :onChangeCallback="(e) => phoneNumberVisible = e.target.checked"
        />

        <FormCheckbox 
          fieldName="emailVisible"
          :modelValue="emailVisible.toString()"
          v-model="emailVisible"
          :label="getLabel('emailVisibleLabel')"
          :onChangeCallback="(e) => emailVisible = e.target.checked"
        />

        <div class="kb-edit-frivillig-profile__actions">

          <button
            class="kb-button kb-button--full-color-spot"
            v-on:click="saveProfile"
            :class="{
                'kb-button--disabled': isSubmitting
              }">
            {{ getLabel("saveButtonText") }}
          </button>

          <button
            class="kb-link kb-stafet-flow-actions__link kb-stafet-flow-actions__link--text-link-color"
            aria-haspopup="true"
            v-on:click="startUserInfoOverlay"
          >
            {{ getLabel("userOverlayText") }}
          </button>
        </div>

        <div class="kb-stafet-step__divider"></div>

        <h2 class="kb-stafet-step__step-section-title">{{ getLabel("interestsTitle") }}</h2>

        <fieldset class="kb-edit-frivillig-profile__fieldset">
          <label class="kb-stafet-step__texts-description">{{ getLabel("interestsDescription") }}</label>
          <div class="kb-edit-frivillig-profile__two-column">
            <div class="kb-stafet-step__input-wrapper" v-for="interest, index in interests" :key="index">
              <FormCheckbox 
                :fieldName="interest.name"
                :modelValue="interest.isSelected.toString()"
                v-model="interest.isSelected"
                :label="interest.name"
                :onChangeCallback="(e) => setInterest(interest.name, e.target.checked)"
              />
            </div>  
          </div>
        </fieldset>

        <div>
          <button
            class="kb-button kb-button--full-color-spot"
            v-on:click="saveProfile"
            :class="{
                'kb-button--disabled': isSubmitting
              }">
            {{ getLabel("saveButtonText") }}
          </button>
        </div>

      </div>
        
      <div class="kb-stafet-step__input-wrapper">
        <div class="kb-stafet-step__divider"></div>
        <h2 class="kb-stafet-step__step-section-title">{{ getLabel("notificationSettingsTitle") }}</h2>

        <fieldset class="kb-edit-frivillig-profile__fieldset">
          <label class="kb-stafet-step__texts-description">{{ getLabel("notificationsDescription") }}</label>
          <div>
            <div class="kb-stafet-step__input-wrapper">
              <FormCheckbox 
                fieldName="notificationWhenCommentOnSavedPosts"
                :modelValue="notificationWhenCommentOnSavedPosts.toString()"
                v-model="notificationWhenCommentOnSavedPosts"
                :label="getLabel('notificationWhenCommentOnSavedPostsLabel')"
                :onChangeCallback="(e) => notificationWhenCommentOnSavedPosts = e.target.checked"
              />
              <FormCheckbox 
                fieldName="notificationWhenDirectMessage"
                :modelValue="notificationWhenDirectMessage.toString()"
                v-model="notificationWhenDirectMessage"
                :label="getLabel('notificationWhenDirectMessageLabel')"
                :onChangeCallback="(e) => notificationWhenDirectMessage = e.target.checked"
              />
              <FormCheckbox 
                fieldName="notificationWhenNewDocument"
                :modelValue="notificationWhenNewDocument.toString()"
                v-model="notificationWhenNewDocument"
                :label="getLabel('notificationWhenNewDocumentLabel')"
                :onChangeCallback="(e) => notificationWhenNewDocument = e.target.checked"
              />
              <FormCheckbox 
                fieldName="notificationWhenPostsOnGroups"
                :modelValue="notificationWhenPostsOnGroups.toString()"
                v-model="notificationWhenPostsOnGroups"
                :label="getLabel('notificationWhenPostsOnGroupsLabel')"
                :onChangeCallback="(e) => notificationWhenPostsOnGroups = e.target.checked"
                />
            </div>  
          </div>
        </fieldset>

        <FormInputDropdown 
          v-model="notificationFrequency"
          :localValue="notificationFrequency"
          fieldName="notificationFrequency"
          :modelValue="notificationFrequency"
          :label="getLabel('notificationFrequencyLabel')"
          :selectOptions="notificationfrequencyOptions"
          :onChangeCallback="(e) => notificationFrequency = e.target.value"
        />

        <FormCheckbox
          fieldName="newsletterBool"
          :modelValue="isSubscribedToNewsletter.toString()"
          v-model="isSubscribedToNewsletter"
          :label="getLabel('newsletterBoolLabel')"
          :onChangeCallback="(e) => setNewsletterSubscription(e.target.checked)"
        />

        <div>
          <button
            class="kb-button kb-button--full-color-spot"
            v-on:click="saveProfile"
            :class="{
                'kb-button--disabled': isSubmitting
              }">
            {{ getLabel("saveButtonText") }}
          </button>
        </div>


        <div class="kb-stafet-step__divider kb-stafet-step__divider--smaller"></div>
        <p class="kb-edit-frivillig-profile__text-no-space">{{ getLabel('deleteProfileText') }} <button v-on:click="startDeleteUserOverlay" class="kb-link" 
          aria-haspopup="true">{{ getLabel('deleteProfileButton') }}</button></p>
        <div class="kb-stafet-step__divider kb-stafet-step__divider--smaller"></div>

      </div>

    </section>
    <div v-if="isSubmitting" class="kb-spinner-overlay">
          <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"></div>
    </div>
  </article>
</template>
